import React, { Component } from 'react';

class SubTitulo extends Component {
    render () {
        return (
            <div className="row">
                <div className="col-md-12">
                    <h3>{this.props.subtitulo}</h3>
                </div>
            </div>
        );
    }
};

export default SubTitulo